const authConfig = {
  loginEndpoint: `/login_check`,
  refreshTokenEndpoint: `/token/refresh`,
  redirectUrl: `/participations`,
  loginUrl: `/login`,
  logoutUrl: `/logout`,
  storageTokenKeyName: "qualytestAccessToken",
};
export const LoginErrorMessage =
  "Une erreur est survenue.\nVeuillez vous reconnecter.";
export const ExpiredRefreshTokenMessage =
  "Votre session a expiré.\nVeuillez vous reconnecter.";

export const expiredTokenErrorMessage = "Token has expired";
export const credentialsSignin = "CredentialsSignin";
export const refreshTokenError = "refresh_token_error";
export default authConfig;
